"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransferParam = /** @class */ (function () {
    function TransferParam(accountId, assetId, amount) {
        this.accountId = accountId instanceof Buffer ? accountId.toString('hex') : accountId;
        this.assetId = assetId instanceof Buffer ? assetId.toString('hex') : assetId;
        this.amount = amount;
    }
    TransferParam.prototype.isAccountId = function (accountId) {
        return this.accountId.toUpperCase() === accountId.toUpperCase();
    };
    TransferParam.prototype.isAssetId = function (assetId) {
        return this.assetId.toUpperCase() === assetId.toUpperCase();
    };
    return TransferParam;
}());
exports.default = TransferParam;
//# sourceMappingURL=transfer-param.js.map